import { createRoot } from 'react-dom/client';
import './assets/tokens.css';
import App from './App';

// Canonical hosts — anything else (raw S3, raw CloudFront, unknown) redirects to prod
const PROD_HOST = 'junior.justizialaw.co.uk';
const DEV_HOST = 'junior-dev.justizialaw.co.uk';
const knownHosts = [PROD_HOST, DEV_HOST, 'localhost', '127.0.0.1'];

if (!knownHosts.includes(window.location.hostname)) {
  window.location.replace(
    `https://${PROD_HOST}${window.location.pathname}${window.location.search}${window.location.hash}`,
  );
} else {
  // Note: StrictMode is intentionally omitted.
  // It double-mounts components in dev, which breaks OAuth code exchange
  // (Cognito auth codes are single-use).
  createRoot(document.getElementById('root')!).render(<App />);
}
